var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"width":"100%","scrolling":"yes","height":"1000","src":"https://knowledge.ivanhoe.io/en","frameborder":"0","allowfullscreen":""}})}
var staticRenderFns = []

export { render, staticRenderFns }